/**
 * @generated SignedSource<<aafdd3fee906c8526329605eb04c0d7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CancelMembershipPlanInput = {
  id: string;
};
export type CancelMembershipPlanButtonMutation$variables = {
  input: CancelMembershipPlanInput;
};
export type CancelMembershipPlanButtonMutation$data = {
  readonly response: {
    readonly cancelledMembershipPlanId: string | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly product: {
      readonly id: string;
      readonly viewerCanCancelMembershipPlan: {
        readonly message: string;
        readonly value: boolean;
      };
    };
    readonly unenrolledProductMembershipId: string | null;
  };
};
export type CancelMembershipPlanButtonMutation = {
  response: CancelMembershipPlanButtonMutation$data;
  variables: CancelMembershipPlanButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v2 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CancelMembershipPlanResponse",
    "kind": "LinkedField",
    "name": "cancelMembershipPlan",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cancelledMembershipPlanId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unenrolledProductMembershipId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CancelMembershipPlan",
            "kind": "LinkedField",
            "name": "viewerCanCancelMembershipPlan",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CancelMembershipPlanButtonMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CancelMembershipPlanButtonMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "76f116d0d09d4b1f83f49c64cd61f3cc",
    "id": null,
    "metadata": {},
    "name": "CancelMembershipPlanButtonMutation",
    "operationKind": "mutation",
    "text": "mutation CancelMembershipPlanButtonMutation(\n  $input: CancelMembershipPlanInput!\n) {\n  response: cancelMembershipPlan(input: $input) {\n    cancelledMembershipPlanId\n    unenrolledProductMembershipId\n    product {\n      id\n      viewerCanCancelMembershipPlan {\n        value\n        message\n      }\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aaae44533950b2ec65a31c65ef54435b";

export default node;
